import React from "react"
import ScrollAnimation from "react-animate-on-scroll"
import HeroBgVid from "./hero-bg-vid"
import HeroBgImg from "./hero-bg-img"
import HeroContent from "./hero-content"
import HomePageStyle from "./home-page.module.scss"

const Hero = () => (
        <div className={HomePageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
        <HeroBgVid />
        <HeroBgImg />
        </ScrollAnimation>
        <HeroContent />
        </div>
    )

export default Hero